import {z} from 'zod';

export const WorkshopOverviewCriticalCountsSchema = z.object({
  vehicleNotArrived: z.number(),
  overpricedOrders: z.number(),
  overdueOrders: z.number(),
  belowMinimumMargin: z.number(),
});
export type WorkshopOverviewCriticalCounts = z.infer<typeof WorkshopOverviewCriticalCountsSchema>;

export const WorkshopOverviewWarningCountsSchema = z.object({
  unclosedWarrantyOrClaim: z.number(),
  noCompletionDate: z.number(),
  noEstimatedPriceSet: z.number(),
  repeatedRepairs: z.number(),
});
export type WorkshopOverviewWarningCounts = z.infer<typeof WorkshopOverviewWarningCountsSchema>;

export const WorkshopOverviewTodayCountsSchema = z.object({
  toCompleteToday: z.number(),
  todayVehicleArrivals: z.number(),
});
export type WorkshopOverviewTodayCounts = z.infer<typeof WorkshopOverviewTodayCountsSchema>;

export const GetWorkshopOverviewApiResponseSchema = z
  .object({
    critical: WorkshopOverviewCriticalCountsSchema.nullish(),
    warning: WorkshopOverviewWarningCountsSchema.nullish(),
    today: WorkshopOverviewTodayCountsSchema.nullish(),
  })
  .nullish();
export type GetWorkshopOverviewApiResponse = z.infer<typeof GetWorkshopOverviewApiResponseSchema>;

export type GetWorkshopOverviewApiArg = void;
